import { render } from "./ShareImportPage.vue?vue&type=template&id=f9fe864a&scoped=true"
import script from "./ShareImportPage.vue?vue&type=script&lang=js"
export * from "./ShareImportPage.vue?vue&type=script&lang=js"

import "./ShareImportPage.vue?vue&type=style&index=0&id=f9fe864a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fe864a"]])

export default __exports__